import { Injectable } from '@angular/core';
import { SessionService } from '@monsido/ng2/core/session/session.service';
import { RequestParamsType } from '@monsido/ng2/external/http/options';
import { MonTableCollection } from '@monsido/ng2/models/table-collection.interface';
import { ApiService } from '../api-service/api.service';
import { BaseRepo, BaseRepoRequestType } from '../base-repo/base-repo';

type PagePdfAccessibilityRepoUpdateCheckErrorRequestType = RequestParamsType & BaseRepoRequestType;
type PagePdfAccessibilityRepoGetCheckErrorsRequestType = RequestParamsType & {
    result_type: string,
};
type PagePdfAccessibilityRepoCheckType = {
    errors_count: number,
    id: number,
    name: string,
};

export type PagePdfAccessibilityRepoCheckErrorType = {
    id: string,
    result_type: string,
    ignored_reviewed: string,
    clarity_accessibility_check_id: string,
    page_id: string,
    page_number: string,
    element_tree_path: string,
    reason: string,
    scanner_comments: string,
    comments: {
        id: string,
        user_id: string,
        subject_id: string,
        subject_type: string,
        comment: string,
        created_at: string,
        updated_at: string
    }[],
    created_at: string,
    updated_at: string,
    latest_check_at: string
};

@Injectable({
    providedIn: 'root',
})
export class PagePdfAccessibilityRepoService extends BaseRepo {

    constructor (private apiService: ApiService, protected sessionService: SessionService) {
        super();
    }

    getAllChecks (pageId: number): Promise<PagePdfAccessibilityRepoCheckType[]> {
        return this.apiService.get<PagePdfAccessibilityRepoCheckType[]>('domains/' + this.getDomainId() + '/pages/' + pageId + '/pdf-accessibility/checks');
    }

    getCheckErrors (pageId: number, checkId: number, params: PagePdfAccessibilityRepoGetCheckErrorsRequestType, config?):
    Promise<MonTableCollection<PagePdfAccessibilityRepoCheckErrorType>> {
        return this.apiService.get<MonTableCollection<PagePdfAccessibilityRepoCheckErrorType>>(
            'domains/' + this.getDomainId() + '/pages/' + pageId + '/pdf-accessibility/checks/' + checkId + '/errors',
            params,
            config,
        );
    }

    updateCheckError (pageId: number, checkId: number, errorId: number, params: PagePdfAccessibilityRepoUpdateCheckErrorRequestType): Promise<void> {
        params = params || {};
        params = this.setGroupId(params);
        return this.apiService.patch<void>(
            'domains/' + this.getDomainId() + '/pages/' + pageId + '/pdf-accessibility/checks/' + checkId + '/errors/' + errorId,
            params,
        );
    }
}
